import { useI18n } from '../i18n';
import { PRODUCT } from '../lib/constants';
import { GetItButton } from '../components/GetItButton';
import { Arrow } from './Hero';
import styles from './FinalCta.module.css';

export function FinalCta() {
  const { t } = useI18n();

  return (
    <section className={styles.section}>
      <h2 className={styles.headline}>
        {t.finalCta.headlineA}
        <br />
        {t.finalCta.headlineB}
      </h2>

      <GetItButton source="final-cta" variant="primary" size="lg">
        {t.finalCta.cta}
        <Arrow />
      </GetItButton>

      <p className={`hand ${styles.domain}`}>{PRODUCT.domain}</p>
    </section>
  );
}
